import React, { useEffect, useState } from 'react';
import ReactTable from './../../../../components/Common/ReactTable/ReactTable';

import { Row, Col } from "react-bootstrap";

import moment from "moment-timezone";

const OverallQueue = (props) => {

    const [alert, setAlert] = useState();
    const [doRefresh, setDoReferesh] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const [inputDataQueueItems, setInputDataQueueItems] = useState([]);

    let inputDataQueueTable = undefined;


    const url = "api/Tenant/GetAllInputBatchJob"; 

    useEffect(() => {
        const fetchData = async (url) => {
            try {
                setIsLoading(true);

                const response = await fetch(url);

                if (response.status === 204) {
                    setInputDataQueueItems([]);
                } else {
                    const data = await response.json();
                    setInputDataQueueItems(data.inputDataQueueItems);
                }

                setIsLoading(false);

            } catch (error) {
                setIsLoading(false);
                throw error;
            }
        };

        fetchData(url);

    }, [url, doRefresh]);

    let data = [];

    if (inputDataQueueItems && inputDataQueueItems.length > 0) {
        data = inputDataQueueItems.map((prop, key) => {
            return {
                received: (prop.received) ? moment.utc(prop.received).local().format("MM/DD/YYYY hh:mm:ss A") : "",
                fileName: prop.fileName,
                jobName: prop.jobName,
                Tenant: prop.tenantName,
                started: (prop.started) ? moment.utc(prop.started).local().format("MM/DD/YYYY hh:mm:ss A") : "",
                errorMessage: prop.errormessage,
                Published: (prop.published) ? moment.utc(prop.published).local().format("MM/DD/YYYY hh:mm:ss A") : "",
            };
        });
    }

    inputDataQueueTable = (
        <ReactTable
            data={data}
            columns={[
                {
                    Header: "Tenant Name",
                    accessor: "Tenant",
                    className: 'rt-custom',
                    maxWidth: 200,
                    minWidth: 200,
                    width: 100,
                },
                {
                    Header: "Job Name",
                    accessor: "jobName",
                    className: 'rt-custom',
                    maxWidth: 150,
                    minWidth: 150,
                    //width: 140,
                },
                {
                    Header: "Started",
                    accessor: "started",
                    className: 'rt-custom',
                    maxWidth: 150,
                    minWidth: 70,
                },
                {
                    Header: "Received",
                    accessor: "received",
                    className: 'rt-custom',
                    maxWidth: 70,
                    minWidth: 150,
                },
                {
                    Header: "Published",
                    accessor: "Published",
                    className: 'rt-custom',
                    maxWidth: 70,
                    minWidth: 150,
                },
                {
                    Header: "File Name",
                    accessor: "fileName",
                    className: 'rt-custom',
                    maxWidth: 150,
                    minWidth: 150,
                    //width: 140,
                },                                               
                {
                    Header: "Error",
                    accessor: "errorMessage",
                    className: 'rt-custom',
                    maxWidth: 200,
                    minWidth: 320,
                },
            ]}            
            className="-striped -highlight primary-pagination"
        />
    );

    return (

        <Row>
            <Col className="mx-auto queues-table pt-3">
                {inputDataQueueTable}
            </Col>
            `   {alert}
        </Row>
    );
}

export default OverallQueue;